import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCarBrandById } from "../../app/services/carBrandService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Form from "react-bootstrap/Form";
import {
  Accordion,
  Breadcrumb,
  Button,
  Col,
  ListGroup,
  Row,
} from "react-bootstrap";
import moment from "moment";
import "moment/locale/sv";

interface Props {}

const CarBrandView: FC<Props> = () => {
  moment.locale("sv");
  const { carBrandId } = useParams<{ carBrandId: string }>();
  const dispatch = useAppDispatch();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const carBrandData = useSelector((state: RootState) => state.carBrand);

  useEffect(() => {
    dispatch(getCarBrandById(instance, account, carBrandId));
  }, [account, accounts, dispatch, instance, carBrandId]);

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/car-brands">Bilmärken</Breadcrumb.Item>
        <Breadcrumb.Item active>{carBrandId}</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form>
        <Row>
          <Col xs={12} md={6}>
          <Form.Group className="mb-3">
              <Form.Label>Bilmärke</Form.Label>
              <Form.Control
                type="text"
                value={carBrandData.carBrand.name}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>

      <Row>
        <div className="text-end">
          <Button variant="primary" href={`/car-brands/${carBrandId}/edit`}>
            Redigera
          </Button>
        </div>
      </Row>

      <div className="mt-3">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Historik</Accordion.Header>
            <Accordion.Body>
              <ListGroup as="ul">
                <ListGroup.Item as="li">
                  <span>
                    Updaterades senast{" "}
                    {moment
                      .utc(carBrandData.carBrand.updatedAt)
                      .local()
                      .format("yyyy-MM-DD HH:mm")}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                  <span>
                    Skapades den{" "}
                    {moment
                      .utc(carBrandData.carBrand.createdAt)
                      .local()
                      .format("yyyy-MM-DD HH:mm")}
                  </span>
                </ListGroup.Item>
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default CarBrandView;
